import { render } from "./Devices.vue?vue&type=template&id=d7e821b0"
import script from "./Devices.vue?vue&type=script&lang=ts"
export * from "./Devices.vue?vue&type=script&lang=ts"
script.render = render

export default script